import React from 'react';
import { string } from 'prop-types';

const NotificationActiveIcon = ({
  color = 'font1-color',
  fontSize = 'var(--base-large)',
  className = ''
}) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_notifications_active ${className}`}
  />
);

NotificationActiveIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default NotificationActiveIcon;
